import React from 'react';

import Loading from '../../Loading';
import useWaterfallData from './useWaterfallData';
import WaterfallView from './WaterfallView';

const WaterfallContent = ({
  chartDefinition,
  chartRef,
  useSmallNoDataMessage,
}: {
  chartDefinition: V5ChartDefinition;
  chartRef: React.MutableRefObject<any>;
  useSmallNoDataMessage: boolean;
}) => {
  const { options, isNoData } = useWaterfallData({
    chartDefinition,
    chartRef,
  });

  if (!options && !isNoData) {
    return <Loading />;
  }

  return (
    <WaterfallView
      chartRef={chartRef}
      options={options ?? {}}
      isNoData={isNoData || !options}
      useSmallNoDataMessage={useSmallNoDataMessage}
    />
  );
};

export default WaterfallContent;
